import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';
import { ChatInterfaceReturn } from './chatServices';

export interface TopicCreateInterface {
	id_barragem: string,
	titulo: string
}

export interface TopicListInteface {
	ativo: boolean,
	data: string,
	id_barragem: string,
	id_responsavel: string,
	responsavel: string,
	uuid: string,
	titulo: string,
	notificados: string[],
	privado: boolean,
}

export interface TopicoInterface {
	ativo: boolean,
	data: string,
	id_barragem: string,
	id_responsavel: string,
	responsavel: string,
	uuid: string,
	titulo: string,
	comentarios: ChatInterfaceReturn[],
	notificados: {
		nome: string,
		uuid: string
	}[],
}

const create = async (data: TopicCreateInterface): Promise<any> => {

	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.post('./topico', data, {
			headers: {
				Authorization: `${token}`
			}
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao criar tópico.');
	} catch (error) {
		console.error(error);
		return new Error((error as { message: string }).message || 'Erro ao criar tópico.');
	}
};


const list = async (uuid: string): Promise<TopicListInteface[] | Error> => {

	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(`./topicos?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`
			}
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao listar registros.');
	} catch (error) {
		console.error(error);
		return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
	}
};

const delet = async (uuid: string): Promise<any | Error> => {

	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.delete(`./topico?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`
			},
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Falha ao deletar registro');
	} catch (error) {
		Error((error as { message: string }).message || 'Erro ao deletar registro');
	}
};

const get = async (uuid: string): Promise<TopicoInterface | Error | undefined> => {

	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(`./topico?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`
			},
		});

		if (response.data !== undefined) {
			return response.data;
		}

		return new Error('Falha ao obter registro');
	} catch (error) {
		Error((error as { message: string }).message || 'Erro ao obter registro');
	}
};

export const TopicServices = {
	create,
	list,
	delet,
	get
};